import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createAmortizationReportApi } from "./api";
import { AmortizationReportReduxTypes } from "./types";

function* createAmortizationReportSaga(action:any):Generator {
    try {
        const response: any = yield call(createAmortizationReportApi, action.payload);
        yield put({
            type: AmortizationReportReduxTypes.AMORTIZATION_REPORT_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: AmortizationReportReduxTypes.AMORTIZATION_REPORT_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchCreateAmortizationReport(): SagaIterator {
    yield takeEvery(AmortizationReportReduxTypes.AMORTIZATION_REPORT, createAmortizationReportSaga);
}

function* amortizationReportSaga(): SagaIterator {
    yield all([fork(watchCreateAmortizationReport)]);
}

export default amortizationReportSaga;  